import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ALIGN, ILanding, ILandingSection, LogoContent } from "src/modules/pe-landing-module/data/interfaces"
import { getCssDemention } from "src/libs/utilities/getCssDemention" 
import { Dummy } from "src/modules/pe-landing-module/views/landing/contentType"
import TestPrimitive from "./TestPrimitive"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"


/* Protopia Ecosystem component */
export interface ILogoProps {
    section: ILandingSection
    data: LogoContent 
}
const Test = ({data, ...props}: ILogoProps): JSX.Element => { 
    const currentLanding:ILanding = useLandingStore((state: ILandingStore) => state.currentLanding)
    const [marginLeft]    = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginRight]   = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "auto" : "0")
    const [marginTop]     = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [marginBottom]  = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [alignItems]    = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "center" : "flex-start")
    const [justify]       = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "center" : "flex-start")
    const [width]         = useState<string>(getCssDemention( data.width,  "inherit" ))
    const [height, ]      = useState<string>(getCssDemention( data.height, "inherit" )) 

    useEffect(() => {
        addCSSClass(
            `landing-test-${props.section.id}`,
            `.landing-test-${props.section.id} {
                display: flex;
                align-items: ${alignItems};
                justify-content: ${justify};
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                max-width: ${ width };
                max-height: ${ height };
                width: ${ width };
                height: ${ height };
                z-index:1;
            } 
            `
        ) 
        return () => {
            removeCSSClass(`landing-test-${props.section.id}`)
        }
    },[ ]) 
    return !!data.test
        ?
        <div className={`landing-menu landing-test-${props.section.id} ${ data.className || "" } `} style={ data.style || {} } >
            <TestPrimitive primitive={ {
                ...data as any,
                titleStyle: { ...currentLanding.title?.style,...data.titleStyle }
            }} />
        </div>
        :
        <Dummy {...{ 
            data: {...data, className: `landing-test-${props.section.id}`}, 
            ...props 
        }} /> 
}
export default Test

 